var map = {
	"./agent-minimum-trade.jpg": 64,
	"./agent-real-time.png": 119,
	"./agent-realtime-commission.jpg": 65,
	"./execution.png": 41,
	"./leverage.png": 40,
	"./metatrader4.jpg": 27,
	"./minimum-trade-max.jpg": 120,
	"./multi-level.jpg": 121,
	"./real-time.jpg": 122,
	"./report-admin-dashboard.jpg": 123,
	"./report-agent-report.jpg": 124,
	"./report-commission-report.png": 125,
	"./service-account.png": 48,
	"./service-copy-trading.png": 47,
	"./service-deposit.png": 43,
	"./service-experience.png": 44,
	"./service-level-system.png": 46,
	"./service-location.png": 45,
	"./strategy.png": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;